import baseBunny from "./base_grey/img_baseBunny_grey.jpg";
import baseBunnyP from "./base_grey/img_baseBunny_grey_p.jpg";

import base from "./base_grey/img_base_grey.jpg";
import baseP from "./base_grey/img_base_grey_p.jpg";

import baseBunnyCrochet from "./base_grey/img_baseBunnyCrochet_grey.jpg";
import baseBunnyCrochetP from "./base_grey/img_baseBunnyCrochet_grey_p.jpg";

import baseBunnyCrochetRattle from "./base_grey/img_baseBunnyCrochetRattle_grey.jpg";
import baseBunnyCrochetRattleP from "./base_grey/img_baseBunnyCrochetRattle_grey_p.jpg";

import baseBunnyRattle from "./base_grey/img_baseBunnyRattle_grey.jpg";
import baseBunnyRattleP from "./base_grey/img_baseBunnyRattle_grey_p.jpg";

import baseCrochet from "./base_grey/img_baseCrochet_grey.jpg";
import baseCrochetP from "./base_grey/img_baseCrochet_grey_p.jpg";

import baseCrochetRattle from "./base_grey/img_baseCrochetRattle_grey.jpg";
import baseCrochetRattleP from "./base_grey/img_baseCrochetRattle_grey_p.jpg";

import baseRattle from "./base_grey/img_baseRattle_grey.jpg";
import baseRattleP from "./base_grey/img_baseRattle_grey_p.jpg";

export default [
    {
        type: "base",
        noPostcard: base,
        withPostcard: baseP,
    },
    {
        type: "baseBunny",
        noPostcard: baseBunny,
        withPostcard: baseBunnyP,
    },
    {
        type: "baseBunnyCrochet",
        noPostcard: baseBunnyCrochet,
        withPostcard: baseBunnyCrochetP,
    },
    {
        type: "baseBunnyCrochetRattle",
        noPostcard: baseBunnyCrochetRattle,
        withPostcard: baseBunnyCrochetRattleP,
    },
    {
        type: "baseBunnyRattle",
        noPostcard: baseBunnyRattle,
        withPostcard: baseBunnyRattleP,
    },
    {
        type: "baseCrochet",
        noPostcard: baseCrochet,
        withPostcard: baseCrochetP,
    },
    {
        type: "baseCrochetRattle",
        noPostcard: baseCrochetRattle,
        withPostcard: baseCrochetRattleP,
    },
    {
        type: "baseRattle",
        noPostcard: baseRattle,
        withPostcard: baseRattleP,
    }
]